import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import device from "src/styles/device";
import font from "src/styles/font";

import { Grid, Box } from "@mui/material";

import { UseUpload } from "src/context/UploadProductContext";
import { convertPrice } from "src/common";

const WrapperGrid = styled.div`
  width: 100%;
  /* margin-top: 24px; */
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  border-radius: 24px 24px 0 0;
  background-color: var(--white-color);
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1); */

  ::-webkit-scrollbar {
    width: 5px;
    height: 7px;
    display: none;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  @media ${device.tabletL} {
    padding-bottom: 0;
    margin-bottom: 24px;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  }
`;

const TextDetail = styled(Box)`
  width: 100%;
  color: ${({ color }) =>
    color === "grey" ? "var(--darkgrey-color)" : "var(--secondary-color)"};
  font-size: ${font.size.sm};
  font-weight: 400;
  margin-bottom: 8px;

  :last-child {
    margin-bottom: 0;
  }

  ${({ nowrap }) =>
    nowrap
      ? css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `
      : css`
          white-space: pre-line;
          word-break: break-word;
        `}/* @media ${device.tabletL} {
    font-size: ${font.size.sm};
  } */
`;

const PriceSummeryDetail = styled.div`
  width: 100%;
  /* margin-top: 24px; */
  /* padding: 24px 24px 40px; */
  border-radius: 0 0 24px 24px;
  background-color: var(--darkwhite-color);

  @media ${device.tabletL} {
    /* padding: 16px; */
    border-radius: 24px;
    margin-bottom: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.10);
  }
`;

const GroupPrice = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

// const PriceLabel = styled.div`
//   font-size: ${font.size.sm};
//   font-weight: 400;
//   color: var(--secondary-color);
// `

const PriceText = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  color: ${({ total }) => (total ? "var(--primary-color)" : "var(--secondary-color)")};

  @media ${device.tabletL} {
    font-size: ${({ price }) => (price ? font.size.md : font.size.sm)};
  }
`

const DetailDataGrid = ({ isDetail, formData }) => {
  const { masterdata } = UseUpload();
  const color_data = masterdata.color_data;
  
  const productHeader = [
    {
      name: 'รหัส',
      key: 'other_code',
      size: {
        xs: 2.4,
        md: 2.7,
      },
      sx: {
        textAlign: "left",
      },
    },
    {
      name: 'รายการ',
      key: 'other_text',
      size: {
        xs: 2,
        md: 2.3,
      },
      sx: {
        textAlign: "left",
      },
    },
    {
      name: 'จำนวน',
      key: 'volume',
      size: {
        xs: 1.45,
        md: 1.3,
      },
      sx: {}
    },
    {
      name: 'ราคาต่อหน่วย',
      key: 'price',
      size: {
        xs: 1.45,
        md: 1.4,
      },
      sx: {}
    },
    {
      name: 'หน่วย',
      key: 'other_unit',
      size: {
        xs: 1.45,
        md: 1.4,
      },
      sx: {}
    },
    {
      name: 'ส่วนลด',
      key: 'discount',
      size: {
        xs: 1.45,
        md: 1.3,
      },
      sx: {}
    },
    {
      name: 'ราคารวมทั้งหมด',
      key: 'total',
      size: {
        xs: 1.8,
        md: 1.6,
      },
      sx: {}
    },
  ];
  
  const serviceHeader = [
    {
      name: 'การบริการ',
      key: 'service_type',
      size: {
        xs: 4,
        md: 6,
      },
      sx: {
        textAlign: "left",
      },
    },
    {
      name: 'จำนวน',
      key: 'volume',
      size: {
        xs: 1.9,
        md: 1.4,
      },
      sx: {}
    },
    {
      name: 'ราคาต่อหน่วย',
      key: 'price',
      size: {
        xs: 1.9,
        md: 1.5,
      },
      sx: {}
    },
    {
      name: 'ส่วนลด',
      key: 'discount',
      size: {
        xs: 1.9,
        md: 1.4,
      },
      sx: {}
    },
    {
      name: 'ราคารวมทั้งหมด',
      key: 'total',
      size: {
        xs: 2.3,
        md: 1.7,
      },
      sx: {}
    },
  ];

  return (
    <>
      <WrapperGrid>
        <Grid
          container
          sx={{
            m: 0,
            width: "100%",
            minWidth: {
              xs: "860px",
              md: "unset",
            },
          }}
        >
          {/* Header */}
          <Grid
            item
            xs={12}
            sx={{
              px: { lg: 5, xs: 3 },
              py: 2,
              backgroundColor: "var(--darkwhite-color)",
              borderRadius: "24px 24px 0 0",
              fontSize: font.size.sm,
            }}
          >
            <Grid
              container
              columnSpacing={2}
              sx={{
                textAlign: "center",
                alignItems: "center",
              }}
            >
              {formData?.document_type === "service"
                ? serviceHeader.map((col, i) => (
                    <Grid
                      key={`${col.key}-header-${i}`}
                      item
                      {...col.size}
                      sx={col.sx}
                    >
                      {col.name}
                    </Grid>
                  ))
                : productHeader.map((col, i) => (
                    <Grid
                      key={`${col.key}-header-${i}`}
                      item
                      {...col.size}
                      sx={col.sx}
                    >
                      {col.name}
                    </Grid>
                  ))}
            </Grid>
          </Grid>

          {formData?.document_type === "service"
            ? formData?.service_list?.length > 0 &&
                formData.service_list.map((service, index) => (
                  <>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        px: { lg: 5, xs: 3 },
                        py: 3,
                        fontSize: font.size.sm,
                        borderBottom: "1px solid var(--lightgrey-color)",
                        "&:last-child": {
                          borderBottom: "none",
                        },
                      }}
                      key={`service-detail-${index}`}
                    >
                      <Grid
                        container
                        columnSpacing={{ xs: 2, lg: 3 }}
                        sx={{ fontSize: font.size.md }}
                      >
                        <Grid item md={6} xs={4}>
                          <TextDetail>
                            {service?.service_type?.service_code}
                          </TextDetail>

                          <TextDetail>
                            {`(${service?.service_type?.service_name}/${
                              getLocale() === "th"
                                ? service?.service_type?.service_unit?.unit_th
                                : service?.service_type?.service_unit?.unit_en
                            })`}
                          </TextDetail>
                        </Grid>

                        <Grid item md={1.4} xs={1.9}>
                          <TextDetail
                            sx={{
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {service?.volume}
                          </TextDetail>
                        </Grid>

                        <Grid item md={1.5} xs={1.9}>
                          <TextDetail
                            sx={{
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {convertPrice(service?.price)}
                          </TextDetail>
                        </Grid>

                        <Grid item md={1.4} xs={1.9}>
                          <TextDetail
                            sx={{
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {convertPrice(service?.discount)}
                          </TextDetail>
                        </Grid>

                        <Grid item md={1.7} xs={2.3}>
                          <TextDetail
                            sx={{
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {convertPrice(service?.total)}
                          </TextDetail>
                        </Grid>

                        {service?.description !== "" ? (
                          <>
                            <Grid
                              item
                              xs={12}
                              sx={{ mt: 3, mb: 2, textAlign: "left" }}
                            >
                              <TextDetail>รายละเอียดการบริการ</TextDetail>
                            </Grid>

                            <Grid item xs={12}>
                              <TextDetail
                                sx={{
                                  pl: 2,
                                  lineHeight: 2.2,
                                }}
                                color="grey"
                              >
                                {service?.description}
                              </TextDetail>
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                    </Grid>
                  </>
                ))
            : (
                <>
                  {formData?.product_list?.length > 0 &&
                    !!formData?.product_list[0].product_choice_id &&
                    formData.product_list?.map((product, index) => (
                      <>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            px: { lg: 5, xs: 3 },
                            py: 3,
                            fontSize: font.size.sm,
                            borderBottom: "1px solid var(--lightgrey-color)",
                            "&:last-child": {
                              borderBottom: "none",
                            },
                          }}
                          key={`product-detail-${index}`}
                        >
                          <Grid
                            container
                            columnSpacing={2}
                            sx={{ fontSize: font.size.md }}
                          >
                            <Grid item xs={2.4} md={2.7}>
                              <TextDetail nowrap>
                                {product?.product_choice_id?.product?.item_code}
                              </TextDetail>

                              <Box
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  mb: 1,
                                }}
                              >
                                <img
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "50%",
                                  }}
                                  src={
                                    color_data.find(
                                      (detail) =>
                                        detail?._id ===
                                        product?.product_choice_id?.color._id
                                    )?.icon_img || ""
                                  }
                                  alt={
                                    product?.product_choice_id?.group_image
                                      ?.product_display_image
                                  }
                                />

                                <TextDetail color="grey" sx={{ ml: 1, mb: 0 }}>
                                  {getLocale() === "th"
                                    ? product?.product_choice_id?.color?.color_th
                                    : product?.product_choice_id?.color?.color_en}
                                </TextDetail>
                              </Box>

                              <TextDetail color="grey">
                                {product?.product_choice_id?.size?.quantity ===
                                "size"
                                  ? `${product?.product_choice_id?.size?.width} ${
                                      getLocale() === "th"
                                        ? product?.product_choice_id?.size
                                            ?.unit_width?.unit_th
                                        : product?.product_choice_id?.size
                                            ?.unit_width?.unit_en
                                    } x ${
                                      product?.product_choice_id?.size?.height
                                    } ${
                                      getLocale() === "th"
                                        ? product?.product_choice_id?.size
                                            ?.unit_height?.unit_th
                                        : product?.product_choice_id?.size
                                            ?.unit_height?.unit_en
                                    } x ${
                                      product?.product_choice_id?.size?.thickness
                                    } ${
                                      getLocale() === "th"
                                        ? product?.product_choice_id?.size
                                            ?.unit_thickness?.unit_th
                                        : product?.product_choice_id?.size
                                            ?.unit_thickness?.unit_en
                                    }`
                                  : product?.product_choice_id?.size?.quantity ===
                                    "capacity"
                                  ? `${
                                      product?.product_choice_id?.size
                                        ?.capacity_size
                                    } ${
                                      getLocale() === "th"
                                        ? product?.product_choice_id?.size
                                            ?.unit_capacity?.unit_th
                                        : product?.product_choice_id?.size
                                            ?.unit_capacity?.unit_en
                                    }`
                                  : getLocale() === "th"
                                  ? "สินค้าสั่งทำพิเศษ"
                                  : "Made by order"}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={2} md={2.3}>
                              <TextDetail>{product?.product_choice_id?.product?.item_name}</TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.3}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  pt: "14px",
                                  textAlign: "center",
                                }}
                              >
                                {product?.volume}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.4}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  pt: "14px",
                                  textAlign: "center",
                                }}
                              >
                                {convertPrice(product?.price)}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.4}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  pt: "14px",
                                  textAlign: "center",
                                }}
                              >
                                {getLocale() === "th"
                                  ? product?.product_choice_id?.group_price?.unit_price?.unit_th
                                  : product?.product_choice_id?.group_price?.unit_price?.unit_en
                                }
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.3}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  pt: "14px",
                                  textAlign: "center",
                                }}
                              >
                                {convertPrice(product?.discount)}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.8} md={1.6}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  pt: "14px",
                                  textAlign: "center",
                                }}
                              >
                                {convertPrice(product?.total)}
                              </TextDetail>
                            </Grid>

                            {product?.description !== "" ? (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sx={{ mt: 3, mb: 2, textAlign: "left" }}
                                >
                                  <TextDetail>รายละเอียดสินค้า</TextDetail>
                                </Grid>

                                <Grid item xs={12}>
                                  <TextDetail
                                    sx={{
                                      pl: 2,
                                      lineHeight: 2.2,
                                    }}
                                    color="grey"
                                  >
                                    {product?.description}
                                  </TextDetail>
                                </Grid>
                              </>
                            ) : null}
                          </Grid>
                        </Grid>
                      </>
                    ))}
                  {formData?.other_list?.length > 0 &&
                    formData?.other_list[0].other_text !== "" &&
                    formData?.other_list[0].other_code !== "" &&
                    formData.other_list.map((product, index) => (
                      <>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            px: { lg: 5, xs: 3 },
                            py: 3,
                            fontSize: font.size.sm,
                            borderBottom: "1px solid var(--lightgrey-color)",
                            "&:last-child": {
                              borderBottom: "none",
                            },
                          }}
                          key={`other-detail-${index}`}
                        >
                          <Grid
                            container
                            columnSpacing={2}
                            sx={{ fontSize: font.size.md }}
                          >
                            <Grid item xs={2.4} md={2.7}>
                              <TextDetail>{product?.other_code}</TextDetail>
                            </Grid>

                            <Grid item xs={2} md={2.3}>
                              <TextDetail>{product?.other_text}</TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.3}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              >
                                {product?.volume}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.4}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              >
                                {convertPrice(product?.price)}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.4}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              >
                                {product?.other_unit}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.45} md={1.3}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              >
                                {convertPrice(product?.discount)}
                              </TextDetail>
                            </Grid>

                            <Grid item xs={1.8} md={1.6}>
                              <TextDetail
                                sx={{
                                  width: "100%",
                                  textAlign: "center",
                                }}
                              >
                                {convertPrice(product?.total)}
                              </TextDetail>
                            </Grid>

                            {product?.description !== "" ? (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sx={{ mt: 3, mb: 2, textAlign: "left" }}
                                >
                                  <TextDetail color="grey">รายละเอียดสินค้า</TextDetail>
                                </Grid>

                                <Grid item xs={12}>
                                  <TextDetail
                                    sx={{
                                      pl: 2,
                                      lineHeight: 2.2,
                                    }}
                                    color="grey"
                                  >
                                    {product?.description}
                                  </TextDetail>
                                </Grid>
                              </>
                            ) : null}
                          </Grid>
                        </Grid>
                      </>
                    ))}
                </>
              )
          }
        </Grid>
      </WrapperGrid>

      <PriceSummeryDetail>
        <Grid
          container
          sx={{
            m: 0,
            width: "100%",
            px: {
              lg: 5,
              md: 3,
              xs: 2,
            },
            pt: {
              md: 3,
              xs: 2,
            },
            pb: {
              md: 5,
              xs: 2,
            },
            ".MuiGrid-item": {
              mb: {
                md: 2,
                xs: 1,
              },
              ":last-child": {
                mb: 0,
              },
            },
          }}
        >
          <Grid item xs={12}>
            <GroupPrice>
              <PriceText>รวมเงิน</PriceText>

              <PriceText price={true}>
                {convertPrice(formData?.total_price || 0)}
              </PriceText>
            </GroupPrice>
          </Grid>

          <Grid item xs={12}>
            <GroupPrice>
              <PriceText>ส่วนลด</PriceText>

              <PriceText price={true}>
                {convertPrice(formData?.discount || 0)}
              </PriceText>
            </GroupPrice>
          </Grid>

          <Grid item xs={12}>
            <GroupPrice>
              <PriceText>มูลค่าหลังหักส่วนลด</PriceText>

              <PriceText price={true}>
                {convertPrice(
                  +formData?.total_price - +formData?.discount || 0
                )}
              </PriceText>
            </GroupPrice>
          </Grid>

          <Grid item xs={12}>
            <GroupPrice>
              <PriceText>ราคารวม Vat7%</PriceText>

              <PriceText price={true}>
                +{convertPrice(formData?.vat || 0)}
              </PriceText>
            </GroupPrice>
          </Grid>

          <Grid item xs={12}>
            <GroupPrice>
              <PriceText>จำนวนเงินทั้งสิ้น</PriceText>

              <PriceText price={true} total={true}>
                {convertPrice(formData?.total_vat || 0)}
              </PriceText>
            </GroupPrice>
          </Grid>
        </Grid>
      </PriceSummeryDetail>
    </>
  );
};

export default DetailDataGrid;
